module.exports = __webpack_public_path__ + "static/img/beer.bc826051.png";